<template>
  <form class="form form-horizontal" v-on:submit="submitForm">
    <modal
      :is-hidden="isHidden"
      :is-open="isOpen"
      :title="title"
      ref="modal"
      v-on:clickclose="closeDialog"
      :alert="alertTitle"
      :alert-style="alertStyle"
      :alert-text="alertText"
      :alert-icon="alertIcon"
      alert-dismissable
      v-on:dismissalert="closeAlert"
      v-on:close="reset"
    >
      <field
        v-for="(field, name) in form"
        :name="name"
        :label="getLabel(name, field.label)"
        :type="field.type"
        :value="formValues[name]"
        :options="field.options"
        :disabled="activeRequest"
        v-if="showField(name)"
        v-on:input="handleFormInput"
      ></field>

      <template slot="footer">
        <button type="button" class="btn btn-sm btn-default" v-on:click="closeDialog">{{ $t('Action.close') }}</button>
        <button type="submit" class="btn btn-sm btn-success" :disabled="activeRequest"><i v-if="activeRequest" class="fa fa-spinner fa-spin"></i> {{ $t('Action.save') }}</button>
      </template>
    </modal>
  </form>
</template>

<script>
import Countries from '../Mixins/Countries.js';

const countryOptions = Object.keys(Countries).map(i => ({
  label: i + ' - ' + Countries[i],
  value: i
}));

var view = require('../view.js'),
    viewData = {
      contactId: null,
      isHidden: true,
      isOpen: false,
      activeRequest: false,
      alertTitle: '',
      alertText: '',
      alertStyle: '',
      alertIcon: '',
      formValues: {
        title: 'company',
        type: 0, // Contact type (0: Company, 1: Person)
        lastname: '',
        firstname: '',
        address: '',
        postalcode: '',
        city: '',
        country: null,
        isShipping: 1,
        isBilling: 1,
        isHome: 0
      },
      form: {
        title: {
          label: 'Common.salutation',
          type: 'select',
          options: {
            company: {
              label: 'Firma'
            },
            mr: {
              label: 'Herr'
            },
            mrs: {
              label: 'Frau'
            }
          }
        },
        lastname: {
          label: 'Common.lastname',
          type: 'text'
        },
        firstname: {
          label: 'Common.firstname',
          type: 'text'
        },
        address: {
          label: 'Common.address',
          type: 'text'
        },
        postalcode: {
          label: 'Common.postalcode',
          type: 'text'
        },
        city: {
          label: 'Common.city',
          type: 'text'
        },
        country: {
          label: 'Common.country',
          type: 'select',
          options: countryOptions
        },
        isShipping: {
          label: 'EditAddress.shipping',
          type: 'select',
          options: [
            {
              value: 0,
              label: 'EditAddress.useForShippingNo'
            },
            {
              value: 1,
              label: 'EditAddress.useForShippingYes'
            },
            {
              value: 2,
              label: 'EditAddress.useForShippingDefault'
            }
          ],
        },
        isBilling: {
          label: 'EditAddress.billing',
          type: 'select',
          options: [
            {
              value: 0,
              label: 'EditAddress.useForBillingNo'
            },
            {
              value: 1,
              label: 'EditAddress.useForBillingYes'
            },
            {
              value: 2,
              label: 'EditAddress.useForBillingDefault'
            }
          ]
        }
      }
    },
    resetData = Object.assign({}, viewData);

export default view(viewData, {
  mounted() {
    this.reset();
  },
  computed: {
    title() {
      return this.$t('EditAddress.title');
    },
    type() {
      return this.formValues.title == 'company' ? 0 : 1;
    },
    isBilling() {
      return typeof this.formValues.isBilling == 'number' ? this.formValues.isBilling : parseInt(this.formValues.isBilling);
    },
    isShipping() {
      return typeof this.formValues.isShipping == 'number' ? this.formValues.isShipping : parseInt(this.formValues.isShipping);
    },
    isHome() {
      return typeof this.formValues.isHome == 'number' ? this.formValues.isHome === 1 : (typeof this.formValues.isHome == 'string' && this.formValues.isHome === '1');
    }
  },
  methods: {
    reset() {
      for (var i in resetData) {
        if (resetData.hasOwnProperty(i)) {
          if (i == 'formValues' || i == 'contactId' || (typeof resetData[i] != 'object' && i != 'isHidden' && i != 'isOpen')) {
            viewData[i] = resetData[i];
          }
        }
      }

      this.closeAlert();
    },
    submitForm(evt) {
      evt.preventDefault();

      if (!this.checkForm()) {
        return;
      }

      if (!this.isHome && !this.isBilling && !this.isShipping) {
        this.alertTitle = this.$t('EditAddress.errorTypeTitle');
        this.alertText  = this.$t('EditAddress.errorTypeText');
        this.alertStyle = 'danger';
        this.alertIcon  = 'exclamation-circle';
        return;
      }

      this.formValues.type = this.type;

      this.closeAlert();
      this.activeRequest = true;

      this.$http.post(this.$root.url + 'address/' + (this.contactId == null ? '' : this.contactId), this.formValues).then(
        function(res) {
          this.activeRequest = false;
          this.$emit('updated', res.data.result);
          this.closeDialog();
        }.bind(this),
        function(res) {
          this.activeRequest = false;

          this.alertTitle = this.contactId == null ? this.$t('EditAddress.errorCreate') : this.$t('EditAddress.errorUpdate');
          if (typeof res.body.error == 'string') {
            this.alertText  = res.body.error;
          }
          this.alertStyle = 'danger';
          this.alertIcon  = 'exclamation-circle';
        }.bind(this));
    },
    checkForm() {
      for (var key in this.form) {
        if (
          this.form.hasOwnProperty(key)
          && (
            (typeof this.formValues[key] == 'undefined')
            || this.formValues[key] == null
            || this.formValues[key] == ''
          )
        ) {
          if (
            key == 'isShipping'
            || key == 'isBilling'
            || key == 'isHome'
            || (key == 'firstname' && this.type == 0)
          ) {
            continue;
          }

          this.alertTitle = this.$t('Common.errorIncomplete');
          this.alertText  = this.$t('Common.errorFieldMissing', {field: this.$t(this.form[key].label)});
          this.alertStyle = 'danger';
          this.alertIcon  = 'exclamation-circle';

          return false;
        }
      }

      return true;
    },
    closeDialog() {
      this.$refs.modal.close(this);
    },
    openDialog(contactId, formValues) {
      this.reset();

      if (typeof formValues == 'object') {
        formValues.title = formValues.type == 0 ? 'company' : formValues.title;
        this.formValues = formValues;
      }

      if (typeof contactId == 'number') {
        this.contactId = contactId;
      }

      this.$refs.modal.open(this);
    },
    closeAlert() {
      this.alertTitle = '';
      this.alertText  = '';
      this.alertStyle = '';
      this.alertIcon  = '';
    },
    handleFormInput(value, field) {
      viewData.formValues[field.name] = value;
      this.$forceUpdate();
    },
    getLabel(name, label) {
      if (name == 'lastname' && this.type == 0) {
        return 'Common.company';
      }

      return label;
    },
    showField(name) {
      if (name == 'firstname' && this.type == 0) {
        return false;
      }

      if (this.isHome && (name == 'isShipping' || name == 'isBilling')) {
        return false;
      }

      return true;
    }
  }
});
</script>
